import classNames from 'classnames'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Body1, Heading6 } from '@ui/Typography'
import { ShoppingCartIcon } from '@ui/icons/ShoppingCart.icon'

import { ScrollToIds } from '@hooks/useScrollToElementIds'

import { Box } from '@shared/components/Box'

import styles from './Subscriptions.module.scss'

interface SubscriptionsTemplateProps {
  subscriptionsHeader: React.ReactNode
  thirdPartySubscriptionsHeader?: React.ReactNode
  subscriptionsTable: React.ReactNode
  thirdPartyTradingSubscriptionsTable?: React.ReactNode
  sidebar: React.ReactNode[]
  isCartEmpty: boolean
  hasSubscriptions: boolean
  isCartItemsLoading: boolean
}

export const SubscriptionsTemplate: React.FC<SubscriptionsTemplateProps> = ({
  thirdPartySubscriptionsHeader,
  thirdPartyTradingSubscriptionsTable: thirdPartyTradingSubcriptionsTable,
  subscriptionsHeader,
  subscriptionsTable,
  sidebar,
  isCartEmpty,
  hasSubscriptions,
  isCartItemsLoading,
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.subscriptionsBox}>
      <div className={styles.subscriptionsTemplateWrapper}>
        <div>
          <div className={styles.subscriptionsHeader}>{subscriptionsHeader}</div>
          <div>{subscriptionsTable}</div>
        </div>

        <div>
          {thirdPartySubscriptionsHeader && (
            <div className={styles.thirdPartySubscriptionsHeader}>
              {thirdPartySubscriptionsHeader}
            </div>
          )}
          {thirdPartyTradingSubcriptionsTable && <div>{thirdPartyTradingSubcriptionsTable}</div>}
        </div>
      </div>
      <div className={styles.sidebarWrapper} id={ScrollToIds.SubscriptionsSidebarWrapper}>
        {!isCartItemsLoading && !hasSubscriptions && (
          <Box color='text-low-em' mb='x12' className={classNames(styles.sidebar)}>
            <Body1 color='text-low-em'>
              <Trans i18nKey='Subscriptions.Side Bar Warnings'>
                <Body1 color='text-danger-high-em' medium>
                  WARNING!
                </Body1>{' '}
                subscription to a <strong>trading platform</strong> and <strong>market data</strong>
              </Trans>
            </Body1>
          </Box>
        )}

        {isCartEmpty ? (
          <div className={styles.sidebar}>
            <Heading6 medium>{t('Subscriptions.Cart')}</Heading6>
            <div className='has-text-centered'>
              <div className='my-4'>
                <ShoppingCartIcon color={'text-base-em'} />
              </div>
              <p className='text'>{t('Subscriptions.Subscriptions cart is empty')}</p>
            </div>
          </div>
        ) : (
          sidebar.map((component, index) => (
            <div key={index} className={styles.sidebar}>
              {component}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
